export var FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export var FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export var FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';